module.exports = __webpack_public_path__ + "img/yinhao.e657ab77.png";